module.exports = __webpack_public_path__ + "static/media/logo.22f8d6b8.png";